import { createContext } from 'react';

const ManageSceneContext = createContext<App.ManageSceneContext>(
    {} as App.ManageSceneContext,
);

export default ManageSceneContext;
